<script setup>
    import SteppersBookingComponent from '@/components/SearchComponents/BookingComponents/SteppersBookingComponent.vue'
</script>
<template>
    <v-container :class="data.class" v-if="cancellation">
        <SteppersBookingComponent :data="{
            cancellation: cancellation,
            start_date: start_date
        }" ></SteppersBookingComponent>
    </v-container>
</template>

<script>
export default {
    props:{
        data:{
            required: true,
            type: Object,
        }
    },
    data: () => ({
        cancellation: null,
        start_date: null,
    }),
    mounted(){
        this.start_date = this.$moment().add(2,'days').add(5,'hours').format()
        this.cancellation = this.$moment().add(0,'days').add(5,'hours').format()
    }
}
</script>